// extracted by mini-css-extract-plugin
export var accActions = "sideNavigation-module--accActions--d54dc";
export var accDrawer = "sideNavigation-module--accDrawer--f2688";
export var accHeadingOpen = "sideNavigation-module--accHeadingOpen--8c972";
export var bar = "sideNavigation-module--bar--1e76a";
export var brand = "sideNavigation-module--brand--f92dd";
export var button = "sideNavigation-module--button--ef517";
export var closeButton = "sideNavigation-module--closeButton--2378b";
export var container = "sideNavigation-module--container--922d0";
export var link = "sideNavigation-module--link--6bbe2";
export var linkGroup = "sideNavigation-module--linkGroup--c94af";
export var navigation = "sideNavigation-module--navigation--2bbb4";
export var sideNavigation = "sideNavigation-module--sideNavigation--08e6d";
export var times = "sideNavigation-module--times--df5f2";